'use client';
import { getRouterPath } from '@/components/routerPath';
import { useUserQuery } from '@/entities/auth/queries';
import {
  useSalePageCommentsCountQuery,
  useSalePageQuery,
} from '@/entities/salePage/queries';
import { useLoginInducingModal } from '@/hooks/useLoginInducingModal';
import { qaAttr } from '@/lib/qa';
import { Element, Icon, Row } from '@vuddy/components';
import { trackEvent } from '@vuddy/utils/src/analytics';
import { isNonNil } from '@vuddy/utils/src/fn';
import { isNil } from 'lodash-es';
import { useRouter } from 'next/navigation';
import * as styles from './commentMoreButton.css';

const CommentMoreButton = ({
  salePageId,
  qaId,
}: {
  salePageId: number;
  qaId?: string;
}) => {
  const router = useRouter();
  const userQuery = useUserQuery();
  const loginConfirm = useLoginInducingModal();
  const salePageQuery = useSalePageQuery(salePageId);
  const { data } = useSalePageCommentsCountQuery(salePageId);

  if (!data || data <= 5) return null;

  const commentsPagePath = isNonNil(salePageId)
    ? getRouterPath().comments(salePageId)
    : '';

  const label = salePageQuery.data?.type === 'CLASS' ? '후기' : '댓글';

  const trackMoreCommentsEvent = () => {
    trackEvent('shop', 'click_sale_comment_more_button', {
      channel_id: salePageQuery.data?.channelId,
      sale_type: salePageQuery.data?.type,
    });
  };

  const onclick = () => {
    // 로그인 체크
    if (!userQuery.isSuccess || isNil(userQuery.data)) {
      loginConfirm();
      return;
    }

    // 로그인된 경우 댓글 상세 페이지로 이동
    trackMoreCommentsEvent();
    router.push(commentsPagePath);
  };

  return (
    <Element marginTop="gap_base" {...(qaId ? qaAttr(qaId) : {})}>
      <Element
        as="button"
        onClick={onclick}
        className={styles.moreCommentsButton}>
        <Row
          gap="gap_xs"
          alignItems="center"
          justifyContent="center"
          typography="bodyXsAccent">
          {label} 더보기 <Icon name="OUTLINE_CHEVRON_RIGHT" size="16px" />
        </Row>
      </Element>
    </Element>
  );
};

export default CommentMoreButton;
